import script from "./ClientDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ClientDetailView.vue?vue&type=style&index=0&id=064a7a66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-064a7a66"]])

export default __exports__